import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import '@/utils/log.ts';
import App from './App.tsx';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from './context/ConfigContext.tsx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 0,
      retry: false
    }
  }
});

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/production').then((d) => ({
    default: d.ReactQueryDevtools
  }))
);

export const Main = () => {
  const [debug, setDebug] = useState(window._isDebugging);

  useEffect(() => {
    const handleDebugChange = () => {
      setDebug(window._isDebugging);
    };

    window.addEventListener('debugChange', handleDebugChange);

    return () => {
      window.removeEventListener('debugChange', handleDebugChange);
    };
  }, []);

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <Router>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
        {debug && (
          <React.Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </React.Suspense>
        )}
      </QueryClientProvider>
    </StrictMode>
  );
};

createRoot(document.getElementById('root')!).render(<Main />);
